<template>
  <li class="pd__item">
    <div class="gutter">
      <div class="img__inner">
        <img class="img-resp"
          :src="item.src"
          :alt="item.name">
      </div>
      <div class="pd__spec">
        <h2 class="pd__name">{{ item.name }}</h2>
        <p class="pd__desc pd__desc--limit" v-if="item.hasLimit">{{ item.desc }}</p>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ['item'],
}
</script>




// WEBPACK FOOTER //
// src/components/Card/CardItemLimit.vue